import React from 'react';
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, isSameDay, isSameMonth, format, isToday as isDateToday } from 'date-fns';

const fallback = { color: '#6B7280' };

export default function MonthView({ date, appointments, onSelectAppointment, onDateSelect, onViewChange, typesMap = {} }) {
  const getType = (key) => typesMap[key] || fallback;
  const monthStart = startOfMonth(date);
  const monthEnd = endOfMonth(date);
  const calStart = startOfWeek(monthStart, { weekStartsOn: 1 });
  const calEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });

  const days = [];
  let d = calStart;
  while (d <= calEnd) { days.push(d); d = addDays(d, 1); }

  const weeks = [];
  for (let i = 0; i < days.length; i += 7) weeks.push(days.slice(i, i + 7));

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="grid grid-cols-7 border-b border-strong bg-secondary">
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(d => (
          <div key={d} className="text-center py-2.5 text-[11px] font-semibold uppercase text-muted-c tracking-wider">
            <span className="hidden sm:inline">{d}</span>
            <span className="sm:hidden">{d.charAt(0)}</span>
          </div>
        ))}
      </div>

      {/* Grid */}
      <div className="flex-1 grid" style={{ gridTemplateRows: `repeat(${weeks.length}, 1fr)` }}>
        {weeks.map((week, wi) => (
          <div key={wi} className="grid grid-cols-7 min-h-0">
            {week.map(day => {
              const dayAppts = appointments.filter(a => isSameDay(a.start, day));
              const isOther = !isSameMonth(day, date);
              const today = isDateToday(day);
              const maxVisible = 3;

              return (
                <div
                  key={day.toISOString()}
                  onClick={() => { onDateSelect(day); onViewChange('day'); }}
                  className={`border-r border-b border-theme p-1 md:p-1.5 cursor-pointer transition-colors hover:bg-hover-surface overflow-hidden flex flex-col
                    ${isOther ? 'opacity-30' : ''}
                    ${today ? 'bg-accent-glow' : ''}`}
                >
                  {/* Date number */}
                  <span className={`text-[11px] md:text-[12px] font-semibold w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0
                    ${today ? 'bg-accent text-white font-bold' : 'text-secondary-c'}`}>
                    {format(day, 'd')}
                  </span>

                  {/* Appointments — overflow hidden */}
                  <div className="mt-0.5 flex flex-col gap-[2px] min-h-0 overflow-hidden flex-1">
                    {dayAppts.slice(0, maxVisible).map(appt => {
                      const typeColor = getType(appt.type).color;
                      return (
                        <div
                          key={appt.id}
                          className="px-1.5 py-[2px] rounded-[4px] cursor-pointer hover:brightness-110 transition-all truncate flex-shrink-0"
                          style={{ background: typeColor }}
                          onClick={(e) => { e.stopPropagation(); onSelectAppointment(appt); }}
                        >
                          <span className="text-[9px] md:text-[10px] text-white font-medium leading-tight">
                            <span className="hidden md:inline">{format(appt.start, 'h:mm')} </span>
                            {appt.client.name.split(' ')[0]}
                          </span>
                        </div>
                      );
                    })}
                    {dayAppts.length > maxVisible && (
                      <div className="text-[9px] md:text-[10px] text-accent-light font-semibold px-1 flex-shrink-0">
                        +{dayAppts.length - maxVisible} more
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
